/**
 * An expected, transient failure of the security master download — a network
 * or 5xx/429 failure, an empty response during a backend pipeline rebuild, a
 * truncated stream, a response that filled the request limit (possible
 * server-side cap), or contract drift across deploys. The load query retries
 * these with backoff. Unexpected errors are deliberately NOT wrapped in this
 * class so they surface as query errors instead of retrying silently forever.
 */
export class SecurityMasterLoadError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'SecurityMasterLoadError';
    }
}
